import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog } from '@yola/ws-ui';

const defaultCaptions = {
  title: 'Something went wrong',
  description: 'Please reload the page',
  dismiss: 'Reload',
};

const defaultOnDismiss = () => window.location.reload();

const CriticalErrorDialog = ({
  handleCancel = null,
  onSubmit = null,
  onDismiss = defaultOnDismiss,
  onDialogMainAction = null,
  onDialogCancel = null,
  captions = defaultCaptions,
  ...otherProps
}) => {
  const extendedProps = {
    handleCancel,
    onSubmit,
    onDismiss,
    onDialogMainAction,
    onDialogCancel,
    captions,
    ...otherProps,
  };

  if (handleCancel) {
    extendedProps.handleCancel = (...args) => {
      onDialogCancel();
      handleCancel(...args);
    };
  }

  if (onSubmit) {
    extendedProps.onSubmit = (...args) => {
      if (onDialogMainAction) onDialogMainAction();
      onSubmit(...args);
    };
  }

  if (onDismiss) {
    extendedProps.onDismiss = (...args) => {
      if (onDialogCancel) onDialogCancel();
      onDismiss(...args);
    };
  }

  return <AlertDialog {...extendedProps} />;
};

CriticalErrorDialog.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    dismiss: PropTypes.string,
  }),
  glyph: PropTypes.string,
  handleCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
  onDialogMainAction: PropTypes.func,
  onDialogCancel: PropTypes.func,
};

export default CriticalErrorDialog;
